export var columnWidth = {
  small: 40,
  "default": 200
};
export var rowHeight = {
  "default": 48,
  expanded: 56
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Table/constants.js
// module id = 231
// module chunks = 0